import { Component } from '@angular/core';

@Component({
  selector: 'app-fieldset',
  standalone: true,
  template: `
    <fieldset class="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-12">
      <div>
        <legend class="text-lg font-medium">
          <ng-content select="[title]"></ng-content>
        </legend>
        <p class="mt-2 text-pretty opacity-65">
          <ng-content select="[description]"></ng-content>
        </p>
      </div>
      <div class="col-span-2">
        <ng-content></ng-content>
      </div>
    </fieldset>
  `,
})
export class FormFieldsetComponent {}
